import { ReactElement } from 'react';

import { createInterpolatedTranslationKey, Translate } from '@dreryk/react-common';

import { translationKeys } from '../../translations';

type ParticipantAgeCellProps = {
   readonly minAge: number;
   readonly maxAge: number;
};

export const ParticipantAgeCell = (props: ParticipantAgeCellProps): ReactElement => {
   return (
      <Translate>
         {createInterpolatedTranslationKey(translationKeys.participantsAgeRange, {
            minAge: props.minAge,
            maxAge: props.maxAge,
         })}
      </Translate>
   );
};
